import {getCategoryList,getCategoryProduct,getProductDetail} from '@/api/product'
const state = {
   
    carouselList:[],
    carouselAllList:[],
    goodsList:[],
    productAttr:[]
    
}
const mutations = {
    GETCATEGORYLIST(state,value){
        state.carouselAllList =value.data.map(item=>{
            return{
                ...item,
                count:0
            }
        })
        // console.log(state.carouselAllList)
       
    },
    GETPRODUCT(state,value){
        state.goodsList = value
        console.log(value)
    },
    GETPRODUCTDETAIL(state,{value,carouselList,cover}){
        state.productDetail = value
        
        state.carouselList =carouselList
        state.productAttr =JSON.parse(value?.attrs)
    },
}
const actions = {
    async getCategoryList({commit},value){
        let res=await getCategoryList()
        // console.log(res,6633)
        commit('GETCATEGORYLIST',{
            data:res.data,
            id:value
        })
    },
    async getProduct({commit},id){
        let res =await getCategoryProduct(id)
        // console.log(res,6633)
        if(res.code == 200){
            commit('GETPRODUCT',res.data)
        }
    },
    async getProductDetail({commit},id){
        let res =await getProductDetail(id)
        // console.log(res)
        if(res.code == 200){
            let carouselList =[]
            res.data.thumbnail.split(',').forEach(element => {
            carouselList.push('https://r9.ruijiiot.com.cn'+element)
        });
            commit('GETPRODUCTDETAIL',{value:res.data,carouselList})
        }
    }
}
const getters = {}
export default {
    namespaced:true,
    state,
    mutations,
    actions,
    getters
}